import { Stepper, StepperStep } from '@customerio/pluma-components/react';
import { Step } from '../types';

type MergeStepperProps = {
  activeStep: Step;
  /** Both people are selected and distinct, so the review step may be entered. */
  hasRequiredSetup: boolean;
  onChangeStep: (step: Step) => void;
};

/**
 * The two-step progress indicator. Only a step the person has not reached may
 * be gated: a disabled current step would render inert, denying the step they
 * are standing on.
 */
export function MergeStepper({ activeStep, hasRequiredSetup, onChangeStep }: MergeStepperProps) {
  const isPreviewCurrent = activeStep === Step.Preview;
  return (
    <Stepper layout="fit" size="sm" aria-label="Merge steps" data-test="people-merge-stepper">
      <StepperStep
        label="Setup"
        status={hasRequiredSetup ? 'complete' : 'incomplete'}
        isCurrent={activeStep === Step.Setup}
        onClick={() => onChangeStep(Step.Setup)}
        data-test="stepper-step-setup"
      />
      <StepperStep
        label="Review and confirm"
        status="incomplete"
        isCurrent={isPreviewCurrent}
        isDisabled={!hasRequiredSetup && !isPreviewCurrent}
        onClick={() => onChangeStep(Step.Preview)}
        data-test="stepper-step-preview"
      />
    </Stepper>
  );
}
